import { Box, styled, Typography } from "@mui/material";
import React from "react";

function ReportHeader() {
  return (
    <SectionWrap component="section" sx={{ position: "relative" }}>
      <ContainerWrap>
        <RowWrap>
          <Col12Wrap>
            <CustomHead component="h2" id="RolerevirTitle">Role Review</CustomHead>
            <CustomText id="RolerevirContent">Setting clear expectations is a key ingredient to ensure strong communication, employee engagement, and career success. Thanks for making an investment in clarity!</CustomText>
          </Col12Wrap>
        </RowWrap>
      </ContainerWrap>
    </SectionWrap>
  );
}

export default ReportHeader;

const SectionWrap = styled(Box)(() => ({
  padding: "25px 0",
  background: "#1085AB",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1170px",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
// const CustomHead = styled(Typography)(() => ({
//   fontSize: "30px",
//   fontWeight: "600",
//   lineHeight: "1.2",
//   color: "#FFFFFF",
//   textAlign: "center",
//   marginBottom: "5px",
//   "@media (max-width: 575px)": {
//     fontSize: "22px",
//   },
// }));
const CustomHead = styled(Typography)(() => ({
  fontSize: "30px",
  fontWeight: "600",
  lineHeight: "1.2",
  color: "#FFFFFF",
  textAlign: "center",
  marginBottom: "5px",
  "@media (max-width: 575px)": {
    fontSize: "22px",
  },
  "&.capture-mode": {
    fontSize: "50px", /* Larger size for PDF capture */
  },
}));

const CustomText = styled(Typography)(() => ({
  fontSize: "20px",
  fontWeight: "400",
  lineHeight: "1.5",
  color: "#FFFFFF",
  textAlign: "center",
  "@media (max-width: 575px)": {
    fontSize: "16px",
  },
}));
